<script setup lang="ts">
import Footer from '~/components/layout/Footer.vue'
import NavigationBar from '~/components/layout/NavigationBar.vue'

const { initLenis, destroyLenis } = useLenis()

onMounted(() => {
  initLenis()
})

onUnmounted(() => {
  destroyLenis()
})

useHead({
  title: 'Syarat & Ketentuan Penggunaan',
})
</script>

<template>
  <main class="min-h-screen bg-white landing-page">
    <NavigationBar />

    <hr>

    <section class="container mx-auto my-24 md:my-32 px-4">
      <div class="mb-10 text-center">
        <h1 class="text-3xl font-bold text-neutral-800">
          Ketentuan dan Persyaratan Penggunaan
        </h1>
      </div>

      <div class="mx-auto max-w-4xl">
        <div class="mt-3 mb-9 text-base text-neutral-800">
          <p class="font-bold">
            Selamat datang di situs Rintisan Billing.
          </p>
          <p class="mt-1">
            Syarat dan ketentuan berikut merupakan perjanjian yang mengikat
            antara Anda sebagai pengguna layanan ("Pengguna") dan PT Rintisan
            Teknologi Waralaba ("Rintisan Billing" atau "kami"). Ketentuan ini
            mengatur hak, kewajiban, serta tanggung jawab Anda dalam mengakses
            dan menggunakan layanan yang tersedia melalui situs
            <strong> billing.rintisan.co.id</strong>, termasuk setiap subdomain
            dan sistem yang terintegrasi dengan platform tersebut ("Situs").
          </p>
          <p class="mt-1">
            Dengan mendaftar atau menggunakan Situs, Anda dianggap telah
            membaca, memahami, dan menyetujui seluruh isi dari Syarat dan
            Ketentuan ini. Jika Anda tidak menyetujui sebagian atau seluruh isi,
            kami sarankan untuk tidak melanjutkan penggunaan layanan.
          </p>
        </div>

        <h3 class="text-xl font-bold text-neutral-800">
          A. Definisi
        </h3>
        <div class="mb-9 text-base text-neutral-800">
          <ul class="ml-12 list-disc">
            <li class="mt-2">
              <span class="font-bold">Rintisan Billing:</span>
              Merujuk pada PT Rintisan Teknologi Waralaba, sebuah perseroan
              terbatas yang menyediakan platform pembayaran untuk bisnis,
              khususnya dalam hal penagihan dan pembayaran melalui platform
              <span class="font-bold">billing.rintisan.co.id.</span>
            </li>
            <li class="mt-2">
              <span class="font-bold"> Situs: </span>
              Seluruh halaman dan sistem yang dapat diakses melalui
              <strong>billing.rintisan.co.id,</strong> baik melalui perangkat
              desktop maupun mobile.
            </li>
            <li class="mt-2">
              <span class="font-bold">Biaya Jasa:</span>
              Biaya yang dikenakan kepada Pengguna atas penggunaan layanan,
              termasuk untuk pemeliharaan sistem dan peningkatan kualitas
              layanan.
            </li>
            <li class="mt-2">
              <span class="font-bold"> Pengguna:</span>
              Pihak yang menggunakan layanan Rintisan Billing, baik sebagai
              pengguna terdaftar maupun pengunjung.
            </li>
            <li class="mt-2">
              <span class="font-bold">Saldo Refund:</span>
              Dana yang ditampung sementara di sistem sebagai hasil dari proses
              pengembalian (refund) transaksi, dan hanya dapat ditarik ke
              rekening bank yang terdaftar atau kembali pada limit kartu
              Pengguna.
            </li>
            <li class="mt-2">
              <span class="font-bold">Ketentuan Situs:</span>
              Merujuk pada Syarat dan Ketentuan ini, Kebijakan Privasi, dan
              ketentuan lain yang berlaku atas penggunaan layanan di Situs.
            </li>
          </ul>
        </div>

        <h3 class="text-xl font-bold text-neutral-800">
          B. Akun, Keamanan, dan Penggunaan Layanan
        </h3>
        <div class="mt-3 mb-9 text-base text-neutral-800">
          <ul class="ml-12 list-decimal">
            <li class="mt-2">
              Pengguna menyatakan berusia minimal 18 tahun atau sudah menikah
              dan memiliki kapasitas hukum untuk menggunakan layanan ini.
            </li>
            <li class="mt-2">
              Kami memiliki hak untuk mengambil tindakan apabila ditemukan
              pelanggaran terhadap Syarat dan Ketentuan ini, termasuk
              menangguhkan atau menutup akun pengguna.
            </li>
            <li class="mt-2">
              Penggunaan sistem Rintisan Billing secara tidak sah atau dengan
              cara yang mengganggu integritas sistem akan dikenakan sanksi.
            </li>
            <li class="mt-2">
              Dilarang menggunakan perangkat otomatis (bot, crawler, emulator)
              untuk mengakses atau mengeksploitasi layanan tanpa izin tertulis
              dari kami.
            </li>
            <li class="mt-2">
              Kami tidak pernah meminta informasi rahasia seperti nomor karti,
              password atau kode OTP. Mohon berhati-hati terhadap pihak yang
              mengatasnamakan Rintisan Billing.
            </li>
            <li class="mt-2">
              Setiap aktivitas dalam akun adalah tanggung jawab pengguna,
              termasuk jika terjadi akses oleh pihak ketiga karena kelalaian
              pengguna.
            </li>
          </ul>
        </div>

        <h3 class="text-xl font-bold text-neutral-800">
          C. Kepatuhan Terhadap Hukum dan Anti Pencucian Uang
        </h3>
        <div class="mt-3 mb-9 text-base text-neutral-800">
          <p class="mb-2">
            Pengguna wajib mematuhi seluruh peraturan terkait pencegahan
            pencucian uang, penipuan, dan pendanaan terorisme yang berlaku di
            wilayah hukum Republik Indonesia. Setiap pelanggaran dapat berakibat
            pada penghentian layanan dan pelaporan kepada pihak berwenang.
          </p>
        </div>

        <h3 class="text-xl font-bold text-neutral-800">
          D. Transaksi Menggunakan Kartu Kredit
        </h3>
        <div class="mt-3 mb-9 text-base text-neutral-800">
          <ul class="ml-12 list-decimal">
            <li class="mt-2">
              Transaksi menggunakan kartu kredit tunduk pada batasan nilai dan
              syarat dari bank penerbit serta payment gateway kami.
            </li>
            <li class="mt-2">
              Apabila terdapat indikasi penyalahgunaan atau pelanggaran hukum,
              kami berhak menahan dana transaksi dan melakukan investigasi
              sekurang-kurangnya 90 (sembilan puluh) hari kerja.
            </li>
            <li class="mt-2">
              Dana hasil transaksi yang dibatalkan akan ditransfer atau
              dikembalikan ke limit kartu kredit dalam periode tagihan
              berikutnya sesuai kebijakan bank.
            </li>
          </ul>
        </div>

        <h3 class="text-xl font-bold text-neutral-800">
          E. Pencairan Dana
        </h3>
        <div class="mt-3 mb-9 text-base text-neutral-800">
          <p>
            Pencairan dana antar rekening bank akan diproses dalam
            <strong>H+1 setiap hari atau sesuai hari kerja</strong> tergantung
            pilihan pembayaran.
          </p>
          <p class="mt-1">
            Jika terdapat indikasi pelanggaran terhadap Syarat dan Ketentuan
            Rintisan Billing, termasuk dugaan kecurangan, manipulasi, atau
            aktivitas mencurigakan lainnya, Pengguna menyetujui bahwa Rintisan
            Billing berhak melakukan pemeriksaan, pembekuan, penundaan, dan/atau
            pembatalan transaksi penarikan dana. Proses ini dapat berlangsung
            selama waktu yang diperlukan oleh tim kami guna memastikan keamanan
            sistem.
          </p>
        </div>

        <h3 class="text-xl font-bold text-neutral-800">
          F. Ketentuan Lain
        </h3>
        <div class="mt-3 mb-9 text-base text-neutral-800">
          <p>
            Dengan menggunakan fitur atau layanan dalam platform Rintisan
            Billing, Pengguna dianggap telah memahami dan menyetujui syarat dan
            ketentuan yang berlaku khusus untuk fitur/layanan tersebut.
          </p>
          <p class="mt-1">
            Jika terdapat hal yang belum diatur dalam ketentuan khusus, maka
            akan mengacu pada Syarat dan Ketentuan Umum Rintisan Billing.
            Persetujuan terhadap Syarat dan Ketentuan ini juga berarti Pengguna
            tunduk pada <strong>Kebijakan Privasi</strong> Rintisan.
          </p>
        </div>

        <h3 class="text-xl font-bold text-neutral-800">
          G. Penolakan Jaminan dan Batasan Tanggung Jawab
        </h3>
        <div class="mt-3 mb-9 text-base text-neutral-800">
          <p>
            Kami selalu berupaya menjaga layanan Rintisan Billing tetap aman,
            stabil, dan dapat digunakan dengan nyaman. Namun, kami tidak
            menjamin bahwa layanan akan selalu berjalan sempurna atau tanpa
            gangguan.
          </p>
          <p class="mt-1">
            Informasi yang ditampilkan pada platform bisa jadi tidak tersedia
            secara real time.
          </p>
          <p class="mt-1">
            Pengguna menggunakan layanan Rintisan Billing atas risiko sendiri,
            dan layanan disediakan
            <strong>"SEBAGAIMANA ADANYA" dan "SEBAGAIMANA TERSEDIA"</strong>.
          </p>
          <p>
            Sejauh diizinkan oleh hukum yang berlaku, Rintisan Billing (termasuk
            perusahaan induk, direktur, dan karyawan) tidak bertanggung jawab
            atas kerugian dalam bentuk apapun, baik langsung maupun tidak
            langsung, yang timbul akibat:
          </p>
          <ul class="ml-12 list-disc">
            <li class="mt-2">
              Penggunaan atau ketidakmampuan dalam menggunakan layanan Rintisan
              Billing
            </li>
            <li class="mt-2">
              Keterlambatan atau gangguan layanan
            </li>
            <li class="mt-2">
              Kelalaian dari pihak Pengguna
            </li>
            <li class="mt-2">
              Transaksi yang dilakukan di luar rekening resmi Rintisan Billing
            </li>
            <li class="mt-2">
              Adanya malware atau tools berbahaya lainnya
            </li>
            <li class="mt-2">
              Kesalahan data atau sistem
            </li>
            <li class="mt-2">
              Kerusakan perangkat keras milik Pengguna
            </li>
            <li class="mt-2">
              Aksi pihak ketiga, termasuk peretasan
            </li>
            <li class="mt-2">
              Perselisihan antara Pengguna
            </li>
            <li class="mt-2">
              Penggunaan tidak sah terhadap akun
            </li>
            <li class="mt-2">
              Dan risiko lainnya yang tidak secara langsung dikendalikan oleh
              Rintisan Billing
            </li>
          </ul>
        </div>

        <h3 class="text-xl font-bold text-neutral-800">
          H. Ketentuan Fitur Khusus
        </h3>
        <div class="mt-3 mb-9 text-base text-neutral-800">
          <p>
            Beberapa fitur tambahan dalam Rintisan Billing memiliki ketentuan
            khusus sebagai berikut:
          </p>
          <p class="mt-2 font-bold">
            1. E-Invoicing (Faktur Digital):
          </p>
          <p>
            Pengguna bertanggung jawab penuh atas isi dan keabsahan faktur yang
            dibuat dan dikirimkan melalui sistem Rintisan Billing. Kami tidak
            bertanggung jawab atas kesalahan penulisan, nominal, atau tujuan
            pengiriman faktur.
          </p>
          <p class="mt-2 font-bold">
            2. Fitur Pembayaran via Marketplace:
          </p>
          <p>
            Fitur ini memungkinkan Pengguna menerima pembayaran dari pembeli
            melalui berbagai saluran marketplace yang terhubung dengan Rintisan
            Billing. Kami hanya berperan sebagai sistem pengelola data
            pembayaran dan tidak bertanggung jawab atas keterlambatan pembayaran
            dari platform marketplace, kesalahan nominal, atau transaksi yang
            dibatalkan oleh pihak ketiga.
          </p>
          <p class="mt-2">
            Pengguna wajib memastikan integrasi akun marketplace dilakukan
            sesuai prosedur, termasuk validasi rekening tujuan untuk pencairan
            dana. Semua transaksi tunduk pada syarat dan ketentuan masing-masing
            marketplace.
          </p>
          <p class="mt-2 font-bold">
            3. Rekening Supplier:
          </p>
          <p>
            Fitur ini memfasilitasi pencatatan dan pembayaran ke rekening
            pemasok yang telah didaftarkan Pengguna dalam sistem Rintisan
            Billing. Pengguna bertanggung jawab penuh atas ketepatan data
            rekening supplier yang dimasukkan, termasuk nama, nomor rekening,
            dan bank tujuan. Kesalahan transfer akibat input data yang tidak
            valid menjadi tanggung jawab Pengguna sepenuhnya. Rintisan Billing
            hanya bertindak sebagai sistem pengelola dan tidak menanggung
            kerugian akibat transfer yang salah alamat.
          </p>
        </div>

        <h3 class="text-xl font-bold text-neutral-800">
          I. Pelepasan Tanggung Jawab
        </h3>
        <div class="mt-3 mb-9 text-base text-neutral-800">
          <p>
            Jika Pengguna mengalami perselisihan dengan pihak lain dalam
            penggunaan platform, Pengguna menyetujui untuk melepaskan Rintisan
            Billing dari klaim, tuntutan, atau kerugian yang muncul dari
            sengketa tersebut—baik yang diketahui maupun tidak diketahui
            sebelumnya.
          </p>
          <p class="mt-2">
            Ini termasuk kerugian akibat transaksi pada produk atau layanan yang
            tidak sesuai ketentuan Rintisan Billing.
          </p>
        </div>

        <h3 class="text-xl font-bold text-neutral-800">
          J. Ganti Rugi
        </h3>
        <div class="mt-3 mb-9 text-base text-neutral-800">
          <p>
            Pengguna setuju untuk membebaskan Rintisan Billing dari segala
            bentuk tuntutan atau kerugian yang muncul akibat pelanggaran
            terhadap Syarat dan Ketentuan, penggunaan layanan yang tidak
            semestinya, maupun pelanggaran terhadap hukum dan hak pihak ketiga.
          </p>
          <p class="mt-2">
            Ini termasuk biaya hukum yang wajar yang mungkin timbul dari klaim
            pihak ketiga.
          </p>
        </div>

        <h3 class="text-xl font-bold text-neutral-800">
          K. Pilihan Hukum dan Pembaruan
        </h3>
        <div class="mt-3 mb-9 text-base text-neutral-800">
          <p>
            Syarat dan Ketentuan ini tunduk dan diatur oleh hukum yang berlaku
            di Republik Indonesia. Setiap sengketa akan diselesaikan secara
            eksklusif melalui pengadilan di wilayah hukum Republik Indonesia.
          </p>
          <p class="mt-2">
            Rintisan Billing dapat memperbarui Syarat dan Ketentuan ini dari
            waktu ke waktu tanpa pemberitahuan sebelumnya. Kami menyarankan
            Pengguna untuk secara berkala membaca halaman ini.
          </p>
          <p class="mt-2">
            Dengan tetap menggunakan layanan setelah perubahan dilakukan,
            Pengguna dianggap menyetujui isi Syarat dan Ketentuan terbaru.
          </p>
        </div>
      </div>
    </section>

    <Footer />
  </main>
</template>
